var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStarsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4731 0.000669976C12.2481 0.0116426 12.0535 0.160343 11.9837 0.374501L9.26073 8.54388H0.540686C0.306666 8.54463 0.0996953 8.69523 0.026879 8.91752C-0.0457678 9.14 0.0321765 9.38385 0.220415 9.52271L7.30348 14.7019L4.58053 23.1561V23.1563C4.5077 23.3801 4.58772 23.6255 4.77842 23.7634C4.96912 23.9013 5.22697 23.9005 5.41693 23.7615L12.5 18.5822L19.5831 23.7615C19.773 23.9005 20.0309 23.9013 20.2216 23.7634C20.4123 23.6255 20.4923 23.3801 20.4195 23.1563L17.6965 14.7021L24.7796 9.5229V9.52271C24.9678 9.38385 25.0458 9.13999 24.9731 8.91752C24.9003 8.69523 24.6933 8.54463 24.4593 8.54388H15.7393L13.0163 0.374501C12.9405 0.141614 12.7182 -0.0114378 12.4736 0.000669976H12.4731Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsvg);
export default __webpack_public_path__ + "static/media/starsvg.2177b3efb120b8de47bcaba06de8ba7f.svg";
export { ForwardRef as ReactComponent };